import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const Logout = () => {
    const navigate = useNavigate();

    useEffect(() => {
        navigate('/dashboard', { replace: true });
        localStorage.removeItem("clientJWT");
        window.location.href = '/dashboard'; // This will reload the page to the root path
    }, [navigate]);

    return null;
};